import { Listing } from 'ha/services/apiV2/types/Listing';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => ({
  address,
  currency,
  kind,
  price,
  type,
  minimumStayMonths,
}: Listing) =>
  makeCall<Listing>('POST', `${APIV2_URL}/listing`, {
    data: {
      address,
      currency,
      kind,
      minimumStayMonths,
      price,
      type,
    },
  });
